export function roundNum(val: number | string, fractionDigits = 2): number {
  if (typeof val === 'string' && val.includes(',')) {
    val = val.replace(',', '.')
  }
  const num = Number(val)
  if (isNaN(num)) {
    return 0
  }
  return Number(num.toFixed(fractionDigits))
}

export function roundEnovaDown(val: number | string): number {
  if (typeof val === 'string' && val.includes(',')) {
    val = val.replace(',', '.')
  }
  const num = Number(val)
  if (isNaN(num)) {
    return 0
  }
  return Math.ceil(Number(num.toFixed(3)) * 100 - 0.5) / 100
}
